import Vue from 'vue';
import '../../../scss/critical.scss';
import '../../../scss/contact_us.scss';
import UserQuestionnaireFormModal from '../../lib-sat/user/modal/user_questionnaire/UserQuestionnaireFormModal.vue';
import { userQuestionnaireModalRouter } from '../../lib-sat/user/modal/user_questionnaire/router';
import { userQuestionnaireModalHelper } from '../../lib-sat/user/modal/user_questionnaire/user-questionnaire-modal-helper';
import Router from 'vue-router';
import { getPiniaInstance } from '../../lib-sat/store/page-store';
import { userManager } from '../../lib-sat/user/user-manager';

Vue.use(Router);

import(
    /* webpackMode: "eager" */
    '../qg-main'
).then(async () => {
    await import(
        /* webpackMode: "eager" */
        '../../qaamgo/modules/sat/user.js'
    );

    await import(
        /* webpackMode: "lazy-once" */
        `../translations/sat-translations.js`
    );

    if (document.getElementById('contactUsModal') === null) {
        const userQuestionnaireModalEl = document.createElement('div');
        userQuestionnaireModalEl.setAttribute('id', 'userQuestionnaireModal');

        document.body.appendChild(userQuestionnaireModalEl);
    }

    const user = await userManager.getUser();

    if (user.isRegistered()) {
        new Vue({
            el: '#userQuestionnaireModal',
            name: 'UserQuestionnaireModalRoot',
            components: { UserQuestionnaireFormModal },
            router: userQuestionnaireModalRouter,
            pinia: getPiniaInstance(),
            render(h) {
                return h(UserQuestionnaireFormModal);
            },
        });

        $('.footer-user-questionnaire').on('click', () => {
            userQuestionnaireModalHelper.openProjectUsage();
        });
    }
});
